import { Box, Heading, Text, TextArea } from 'native-base'
import { FormikProps } from 'formik'

import { colors } from '../../utils/theme/configureTheme'
import ExperienceRatingSmiley from '../ExperienceRatingSmiley'
import OptionChips from '../FeedbackForm/OptionChips'
import { SUPPORT_ISSUE_OPTIONS } from '../FeedbackForm/types'
import { SupportFeedbackFormValues } from './types'

interface AgentExperienceSectionProps {
  formikProps: FormikProps<SupportFeedbackFormValues>
}

/** Support feedback form section for rating the support agent and capturing issue reasons. */
export default function AgentExperienceSection({ formikProps }: AgentExperienceSectionProps) {
  const { values, setFieldValue } = formikProps

  return (
    <Box px={4} pb={4}>
      <Heading fontSize={18} fontWeight="600" fontFamily="bodySemiBold" color={colors.brand.vermillion} mb={3}>
        Support Experience
      </Heading>
      <Box backgroundColor={colors.brand.white} borderRadius={12} p={4} borderWidth={1} borderColor={colors.gray[200]}>
        <ExperienceRatingSmiley
          header="How did our Support Agent do?"
          onSmileyPress={rating => {
            setFieldValue('overallSupportExperience', rating)
            if (rating > 2) {
              setFieldValue('supportIssues', [])
            }
          }}
          existingRating={values.overallSupportExperience ?? undefined}
        />
        {values.overallSupportExperience !== null && values.overallSupportExperience <= 2 && (
          <OptionChips
            options={SUPPORT_ISSUE_OPTIONS}
            selected={values.supportIssues}
            onChange={reasons => setFieldValue('supportIssues', reasons)}
            columns={2}
          />
        )}
        {values.overallSupportExperience !== null && (
          <Box mt={2}>
            <Text fontSize={14} fontWeight="500" fontFamily="Matter Regular" mb={2}>
              Any additional information you want to provide?
            </Text>
            {/* @ts-expect-error missing tvParallaxProperties, onTextInput */}
            <TextArea
              value={values.supportComments}
              onChangeText={text => setFieldValue('supportComments', text)}
              placeholder="Tell us more about your support experience..."
              autoCompleteType={undefined}
              h={100}
              borderWidth={2}
              borderColor={colors.brand.softBlack}
              borderRadius={8}
              fontSize={14}
              fontFamily="Matter Regular"
              p={3}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}
